import React from "react";
import { Skeleton } from "@material-ui/lab";
import { Box, Grid } from "@material-ui/core";

const InventorySkeleton = () => {

    return (
        <Box className="inventory-container container">
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Skeleton
                        animation="wave"
                        variant="rect"
                        width={"100%"}
                        height={85}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    {[
                        "Furniture",
                        "Electricals",
                        "Vehicles",
                        "Other Appliances",
                        "Boxes/Trolley",
                        "Musical",
                    ].map((value, index) => {
                        return (
                            <div className="mb-3" key={index}>
                                <Skeleton
                                    animation="wave"
                                    variant="rect"
                                    style={{ minWidth: '7rem' }}
                                    width={"100%"}
                                    height={50}
                                />
                            </div>
                        );
                    })}
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8}>
                    {[1, 2, 3, 4, 5, 6].map((value, index) => {
                        return (
                            <div className="mb-3" key={index}>
                                <Skeleton
                                    animation="wave"
                                    variant="rect"
                                    width={"100%"}
                                    height={"4rem"}
                                />
                            </div>
                        );
                    })}
                </Grid>
            </Grid>
        </Box>
    );
}

export default InventorySkeleton;